{
  "version": 1,
  "asset_id": "8e5730fd-1433-4d87-8c0d-6368924a202a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8e5730fd-1433-4d87-8c0d-6368924a202a/bypass-revision-downsizing-es-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8e5730fd-1433-4d87-8c0d-6368924a202a/bypass-revision-downsizing-es-320.webp",
  "original_filename": "bypass-revision-downsizing-es-320.webp",
  "size": 15978,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:27Z"
}
